import { useQuery } from '@tanstack/react-query';

import { catalogOptions } from './catalog.options';

export const useSpotCatalog = () => {
  return useQuery(catalogOptions.spot());
};

export const useForwardCatalog = () => {
  return useQuery(catalogOptions.forward());
};
